import React from 'react';
import { Currency } from 'types';

export const CurrencyContext = React.createContext<Currency>('USD');
